<template>
  <div class="mt-3 alert alert-danger">
    <legend>Недоставленные заказы</legend>
    <div class="mb-2">
      <div v-for="tour in items">
        <span>{{tour.TourName}}: </span>
        <router-link v-for="order in tour.Orders" :to="{ name: 'order-info', params: {orderId: order.OrderItemId}}"
                     class="text-decoration-none text-danger"
                     target="_blank">
          {{order.SferaNumber}}
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['items'],
};
</script>
